import { ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { Component, Input } from '@angular/core';
import { EnumCustomerAddressTypes } from '@dato-proxy/enums';
import { BaseGridComponent } from '@m4u-angular/base/component/BaseGridComponent';
import { CustomerAddress } from '@dato-proxy/entities/customeraddress.entity';

@Component({
    providers: ServiceBagServices,
    selector: 'app-customer-address-grid',
    templateUrl: './customer-address-grid.component.html',
    styleUrls: ['./customer-address-grid.component.scss']
})
export class CustomerAddressGridComponent extends BaseGridComponent<CustomerAddress, BaseState>
{
    @Input() public Type: EnumCustomerAddressTypes;

    constructor(A: ServiceBagService) {
        super(A, 'CustomerAddressGridComponent', CustomerAddress, BaseState);
    }

    OnNavigate(e) {
        // condition is the same for editing and adding
        if (!this.ShowAddButton) return;

        this.Navigate(["/pages/customer-address/", e.data.EntryID], { Type: this.Type });
    }
}
